import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  Outlet, useLocation, useNavigate,
  useParams,
} from 'react-router-dom';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg';
import Button from 'components/Button/Button';
import Panel from 'components/Panel/Panel';
import StepsList from 'components/StepsList/StepsList';
import AppRoutes from 'constants/AppRoutes';
import { INITIATE } from 'constants/general';
import { BUTTON_VARIANT } from 'constants/interfaces';
import { DEFAULT_STEP, MATERIAL_ASSESSMENT_STEPS } from 'constants/materialAssessment';
import { setStakeholderVcTab } from 'store/slices/general/slice';
import { useGetSectionsMAQuery } from 'store/slices/layoutsMA/apis/materialAssessmentApi';
import { setMaterialId } from 'store/slices/materialAssessment/slice';

import styles from './scss/MaterialAssessmentLayout.module.scss';

function MaterialAssessmentLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { recordId = '' } = useParams();

  const { data: sectionsData } = useGetSectionsMAQuery({
    maId: recordId,
  }, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (recordId) {
      dispatch(setMaterialId(Number(recordId)));
    }
  }, [recordId, dispatch]);

  const goBack = () => {
    navigate(AppRoutes.materialityAssessment);
    dispatch(setStakeholderVcTab(null));
  };
  const onStepChange = (stepType: string) => {
    if (stepType === INITIATE && recordId) {
      navigate(AppRoutes.materialityAssessmentInitiate.replace(':recordId', recordId));
    }

    if (recordId && stepType !== INITIATE) {
      navigate(`${AppRoutes.materialityAssessment}/${recordId}/${stepType}`);
    }
  };

  return (
    <div className={styles.root}>
      <Panel className={styles.panel}>
        <div className={styles.container}>
          <div className={styles.left}>
            <Button
              title={t('materialityAssessment.back')}
              onClick={goBack}
              variant={BUTTON_VARIANT.ghost}
              startIcon={<ArrowLeftIcon />}
            />
            <StepsList
              step={!Number(location.pathname.split('/')[3]) && location.pathname.split('/')[3]
                ? location.pathname.split('/')[3] : DEFAULT_STEP}
              stepsList={MATERIAL_ASSESSMENT_STEPS}
              handleStepChange={onStepChange}
              optionList={sectionsData?.data.items}
              recordId={recordId || ''}
              statusActiveButton
            />
          </div>
          <div className={styles.right}>
            <Outlet />
          </div>
        </div>
      </Panel>
    </div>
  );
}

export default MaterialAssessmentLayout;
